import { Navigate } from '@ngxs/router-plugin';
import { StateContext } from '@ngxs/store';
import { FullFilters } from '../models/full-filters.model';
import {
  FormatCallback,
  getFilterAsQuerystring,
  noopFormat,
} from './get-filter-as-querystring';

export function setFiltersInUrl<TState>(
  ctx: StateContext<TState>,
  url: string,
  { filters, pageIndex, pageSize, order }: FullFilters,
  format: FormatCallback = noopFormat
): void {
  const data = getFilterAsQuerystring(
    { pageIndex, pageSize, filters, order },
    format
  );
  const action = new Navigate([url], {
    ...Object.fromEntries(data),
  });
  ctx.dispatch(action);
}
